import Flex from "@irati/ui/src/Flex"
import {H4} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React, {useState} from "react"
import Button from "@irati/ui/src/Button"
import {useRewardsDistribution} from "../../stores/DistributeReward/hooks"
import PreviewContent from "./PreviewContent"
import FullPreview from "./FullPreview"

interface Props {
  generic?: boolean
  boxed?: boolean
}
const TemplatePreview = (props: Props) => {
  const {generic, boxed} = props
  const payload = useRewardsDistribution()
  const [showModal, setShowModal] = useState(false)
  if (!payload.rewardTemplate) {
    return null
  }
  const templatePreviewProps = {
    rewardMessage: payload.message,
    rewardPoints: payload.pointsPerUser,
    rewardTitle: payload.rewardTemplateTitle,
    rewardTemplate: payload.rewardTemplate
  }
  return (
    <Flex paddingLeft={3} paddingRight={3} paddingTop={4} direction="column">
      <Flex justifyContent="space-between" alignItems="center">
        <H4>
          <FormattedMessage id="wallet.reward.template.preview" />
        </H4>
        <Button onClick={() => setShowModal(true)} cta>
          <FormattedMessage id="wallet.reward.template.previewCTA" />
        </Button>
      </Flex>
      <PreviewContent generic={generic} boxed={boxed} {...templatePreviewProps} />
      <FullPreview {...templatePreviewProps} show={showModal} onHide={() => setShowModal(false)} />
    </Flex>
  )
}

export default TemplatePreview
